import { z } from 'zod';
import { uuid } from './common.js';
const optText = (max) => z.string().trim().max(max).nullable().optional();
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD');
const hhmm = z.string().regex(/^\d{2}:\d{2}(:\d{2})?$/, 'HH:MM');
// ── club event series (Vereinstermine, wiederkehrend) ───────────────────────
// Same recurrence shape as training (packages/contracts/src/training.ts,
// apps/api/src/training/recurrence.ts) — reused as-is, not reimplemented.
export const clubEventSeriesBase = z.object({
    title: z.string().trim().min(1).max(160),
    description: optText(2000),
    venue: optText(200),
    /** Visibility filter, not a registration target — a club event has no
     * sign-up. Single team/group (not the multi-select training uses),
     * since "who should see this" is a simpler question than "who is this
     * training session for". `null`/unset on both = visible to the whole club. */
    teamId: uuid.nullable().optional(),
    trainingGroupId: uuid.nullable().optional(),
    frequency: z.enum(['weekly', 'interval']).default('weekly'),
    weekdays: z.array(z.number().int().min(1).max(7)).min(1),
    intervalWeeks: z.number().int().min(1).max(12).default(1),
    startDate: isoDate,
    endDate: isoDate.nullable().optional(),
    occurrenceCount: z.number().int().positive().max(400).nullable().optional(),
    startTime: hhmm,
    endTime: hhmm,
});
export const clubEventSeriesWritable = clubEventSeriesBase
    .refine((s) => s.endDate != null || s.occurrenceCount != null, {
    message: 'endDate oder occurrenceCount angeben',
    path: ['endDate'],
})
    .refine((s) => s.endDate == null || s.endDate >= s.startDate, {
    message: 'Enddatum darf nicht vor dem Startdatum liegen',
    path: ['endDate'],
});
export const clubEventSeriesPatch = clubEventSeriesBase.partial();
export const generateClubEventSeriesRequest = z.object({
    until: isoDate.optional(),
    pruneOutside: z.boolean().default(false),
});
// ── club events (single occurrence) ─────────────────────────────────────────
export const clubEventWritable = z.object({
    title: z.string().trim().min(1).max(160),
    description: optText(2000),
    venue: optText(200),
    teamId: uuid.nullable().optional(),
    trainingGroupId: uuid.nullable().optional(),
    eventDate: isoDate,
    startTime: hhmm,
    endTime: hhmm,
});
export const updateClubEventRequest = clubEventWritable.partial().extend({
    status: z.enum(['scheduled', 'cancelled']).optional(),
    cancelledReason: optText(500),
});
// ── aggregated calendar view ─────────────────────────────────────────────────
export const CALENDAR_ENTRY_TYPES = ['match', 'training', 'club_event'];
export const calendarQuery = z.object({
    from: isoDate,
    to: isoDate,
    /** comma-separated — defaults to all three when omitted */
    types: z.string().optional(),
    teamIds: z.string().optional(),
    trainingGroupIds: z.string().optional(),
    mine: z.enum(['true', 'false']).optional(),
});
//# sourceMappingURL=calendar.js.map